import { useMatchMedia } from '#app/hooks/useMatchMedia.js';
import { theme } from '#app/theme/theme.js';
import { type DefaultProperties } from '#app/types/analytics/propertyLibrary.js';
import { parseMediaQueryForMatchMedia } from '#app/utilities/parseMediaQueryForMatchMedia.js';

export const useDeviceCategory = (): DefaultProperties['device_category'] => {
  const isUltrawide = useMatchMedia(`screen and (min-width: 1440px)`);
  const isDesktop = useMatchMedia(
    parseMediaQueryForMatchMedia(theme.mediaQueries.lg),
  );
  const isTablet = useMatchMedia(
    parseMediaQueryForMatchMedia(theme.mediaQueries.sm),
  );

  if (isUltrawide) return 'ultrawide';
  if (isDesktop) return 'desktop';
  if (isTablet) return 'tablet';

  return 'mobile';
};
